export const GATEWAY_API_BASEPATH = process.env.REACT_APP_GATEWAY_API_BASEPATH
export const GATEWAY_API_HEALTH_URL = `${GATEWAY_API_BASEPATH}/health`
export const GATEWAY_API_USER_URL = `${GATEWAY_API_BASEPATH}/userinfo`
export const GATEWAY_API_USERS_URL = `${GATEWAY_API_BASEPATH}/users`
export const GATEWAY_API_GROUPS_URL = `${GATEWAY_API_BASEPATH}/groups`
export const GATEWAY_API_APPS_URL = `${GATEWAY_API_BASEPATH}/apps`
export const GATEWAY_API_ERROR_URL = `${GATEWAY_API_BASEPATH}/error`
export const GATEWAY_API_CAMPIAGN_URL = `${GATEWAY_API_BASEPATH}/campaigns`
export const GATEWAY_API_USER_REGISTERED_APPS_URL = `${GATEWAY_API_BASEPATH}/api/me/applications`
export const OKTA_ISSUER = process.env.REACT_APP_OKTA_ISSUER
export const OKTA_CLIENTID = process.env.REACT_APP_OKTA_CLIENTID
export const GA_ID = process.env.REACT_APP_GA_ID
export const JANSSEN_OKTA_ISSUER = process.env.REACT_APP_JANSSEN_OKTA_ISSUER
export const JANSSEN_OKTA_CLIENTID = process.env.REACT_APP_JANSSEN_OKTA_CLIENTID
export const OKTA_BASE_REDIRECT_URI =
  process.env.REACT_APP_OKTA_BASE_REDIRECT_URI

export const OKTA_CONFIG_OBJ = {
  issuer: OKTA_ISSUER,
  clientId: OKTA_CLIENTID,
  redirectUri: `${OKTA_BASE_REDIRECT_URI}/login/callback`,
  restoreOriginalUri: async (oktaAuth, originalUri) => {
    window.location.replace(originalUri)
  },
}

export const JANSSEN_OKTA_CONFIG_OBJ = {
  issuer: JANSSEN_OKTA_ISSUER,
  clientId: JANSSEN_OKTA_CLIENTID,
  redirectUri: `${OKTA_BASE_REDIRECT_URI}/login/callback`,
  restoreOriginalUri: async (oktaAuth, originalUri) => {
    window.location.replace(originalUri)
  },
}
export const SIDE_MENU_SECTIONS = [
  {
    name: 'Users',
    open: true,
    links: [
      { label: 'Create User', path: '/create-user' },
      { label: 'User Search', path: '/search-user' },
    ],
  },
  {
    name: 'Groups',
    open: true,
    links: [
      { label: 'Create Group', path: '/create-group' },
      { label: 'Group Search', path: '/search-group' },
    ],
  },

  {
    name: 'Applications',
    open: true,
    path: '/not-available',
    links: [
      // { label: 'Create Applications', path: '/create-application' },
      // { label: 'Search Applications', path: '/search-application' },
    ],
  },
  {
    name: 'Access Certifications',
    open: true,
    path: '/not-available',
    links: [
     // { label: 'Manage Certifications', path: '/create-campaign/0' },
  ], }
  // {
  // name: 'Audits',
  // open: false,
  // links: [{ label: 'Search Audit', path: '/search-audit' }],
  // },
  // {
  //   name: 'Access Request',
  //   open: false,
  //   links: [{ label: 'Pending Request', path: '/pending-request' }],
  // },
  // {
  //   name: 'Brannds',
  //   open: false,
  //   links: [
  //     { label: 'Create Brand', path: '/' },
  //     { label: 'Modify Brand', path: '/' },
  //   ],
  // },
]

export const domains = [{
  domainName: 'dev.login.jnj.com',
  companyName: 'J&J'
}];

export const colors = ['#f1e1d4', '#dac9ac', '#fadcd2', '#dfb6a4', '#c38a81', '#f5b381', '#dac3ba']

export const BANNER_MENU_SECTIONS = [
  {
    label: 'home-tab',
    path: '/'
  },
]
export const BANNER_DROPDOWN_MENU_SECTIONS = [
  {
    label: 'my-profile-tab',
    path: '/user-profile',
  },
  {
    label: 'sign-out-tab',
    path: '/logout',
    color: 'red'
  }
]
export const HAMBURGER_MENU_SECTIONS = [
  [
    {
      label: 'home-tab',
      path: '/home'
    },
    {
      label: 'my-account-tab',
      path: '/user-profile'
    },
  ],
  [
    {
      label: 'sign-out-tab',
      path: '/logout'
    },
  ]
]
